module.exports = __webpack_public_path__ + "static/media/vertical-ellipsis-hover.3c87d9f2.svg";